module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "overview"
    }
  }, [(!_vm.isLoaded) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), (_vm.is_empty) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v(_vm._s(_vm.empty_msg))]) : _c('div', {
    staticClass: "events"
  }, [(_vm.events_show) ? [_c('section', [_vm._v(_vm._s(_vm.$t('events')))]), _vm._v(" "), _c('div', {
    staticClass: "content content_p"
  }, [_c('span', {
    staticClass: "icon_start"
  }), _vm._v(" "), _c('ol', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.match_data.events), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "cf"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.minute))]), _vm._v(" "), (item.teamAEvents.length !== 0) ? _c('div', {
      staticClass: "home"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _vm._l((item.teamAEvents), function(team, index) {
      return _c('p', {
        key: index
      }, [_c('span', {
        staticClass: "person"
      }, [_c('span', {
        staticClass: "text_lim"
      }, [_vm._v(" " + _vm._s(team.person) + " ")]), _vm._v(" "), _c('img', {
        attrs: {
          "src": _vm.getImgSrc(team.event_pic)
        }
      })])])
    })], 2) : _vm._e(), _vm._v(" "), (item.teamBEvents.length !== 0) ? _c('div', {
      staticClass: "away"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _vm._l((item.teamBEvents), function(team, index) {
      return _c('p', {
        key: index
      }, [_c('span', {
        staticClass: "person"
      }, [_c('img', {
        attrs: {
          "src": _vm.getImgSrc(team.event_pic)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text_lim"
      }, [_vm._v(" " + _vm._s(team.person) + " ")])])])
    })], 2) : _vm._e()])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_end"
  })]), _vm._v(" "), _c('div', {
    staticClass: "show"
  }, [_c('div', {
    staticClass: "show_main"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../assets/match/icon_goal.png"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('goal')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/match/icon_point.png"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('penalty')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/match/icon_point_1.png"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('penaltySaved')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/match/icon_w.png"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('ownGoal')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/match/icon_a.png"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('assist')))])])])] : _vm._e(), _vm._v(" "), (_vm.statistics_show) ? [_c('section', [_vm._v(_vm._s(_vm.$t('statistics')))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('table', {
    staticClass: "head"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "away"
  }, [_c('span', {
    staticClass: "team"
  }, [_c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.match_data.statistics.team_A.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.match_data.statistics.team_A.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
    staticClass: "home"
  }, [_c('span', {
    staticClass: "team"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.match_data.statistics.team_B.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.match_data.statistics.team_B.name))])])])])])]), _vm._v(" "), (_vm.statistics_show) ? _c('table', [_c('tbody', _vm._l((_vm.match_data.statistics.list), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "away"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.team_A.value))]), _vm._v(" "), _c('span', {
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "ranks",
      class: item.team_A.class,
      style: ({
        width: item.team_A.per + '%'
      })
    })])]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticClass: "home"
    }, [_c('span', {
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "ranks",
      class: item.team_B.class,
      style: ({
        width: item.team_B.per + '%'
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.team_B.value))])])])
  }))]) : _vm._e()])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cf"
  }, [_c('span', {
    staticClass: "dot_s"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-364a85e9","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/matchOverview.vue
// module id = 651
// module chunks = 2